module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section04_08_american-village-073c4b106f5f8b90f9dc092de1e8ed59.jpg";